const PAYMENT_METHODS = {
  CERTIFICATION_BACKSTAGE_MULTIPLE: 'CERTIFICATION_BACKSTAGE_MULTIPLE',
  CERTIFICATION_FORESTAGE: 'CERTIFICATION_FORESTAGE',
  ACTIVITY_FORESTAGE: 'ACTIVITY_FORESTAGE',
  ACTIVITY_BACKSTAGE_MULTIPLE: 'ACTIVITY_BACKSTAGE_MULTIPLE',
  TOURNAMENT_FORESTAGE: 'TOURNAMENT_FORESTAGE',
  TOURNAMENT_BACKSTAGE_MULTIPLE: 'TOURNAMENT_BACKSTAGE_MULTIPLE',
  EXAM_FORESTAGE: 'EXAM_FORESTAGE',
  EXAM_BACKSTAGE_MULTIPLE: 'EXAM_BACKSTAGE_MULTIPLE',
};

export {PAYMENT_METHODS};
